import type { TextosPortal } from './pt';

/** Portal do Cliente (Onda 1): textos do app "Malgo" em espanhol. */
export const portalEs: TextosPortal = {
  app: { nome: 'Malgo', subtitulo: 'Portal del cliente', carregando: 'Cargando el portal', titulo: 'Tu empresa y Malgo, en el mismo lugar.', texto: 'Facturas, documentos y conversación con el equipo, en el celular o en la computadora.' },
  faixa: { sandbox: 'Sandbox: entorno de prueba', verComo: 'Vista del equipo de Malgo: solo lectura, registrada en la auditoría' },
  menu: { hoje: 'Hoy', saida: 'Tu acceso', financeiro: 'Finanzas', relatorios: 'Informes', documentos: 'Documentos', mensagens: 'Mensajes', perfil: 'Perfil', empresas: 'Cambiar de empresa', sair: 'Salir', principal: 'Navegación del portal', conta: 'Cuenta y empresa' },
  entrar: {
    passkey: 'Entrar con passkey (Face ID, huella)',
    passkeyErro: 'Passkey no reconocida. Entra con el código del correo.',
    titulo: 'Entrar al portal',
    texto: 'Escribe tu correo. Enviamos un código y un enlace de acceso, sin necesidad de contraseña.',
    email: 'Correo',
    pedir: 'Recibir código',
    enviado: 'Si el correo tiene acceso al portal, el código llega en un momento. Revisa también la carpeta de spam.',
    codigo: 'Código de 6 dígitos',
    confirmar: 'Entrar',
    reenviar: 'Enviar otro código',
    trocarEmail: 'Usar otro correo',
    comSenha: 'Entrar con contraseña',
    semSenha: 'Entrar con código por correo',
    senha: 'Contraseña',
    lembrar: 'Recordar este dispositivo por 30 días',
    codigoInvalido: 'Código incorrecto o vencido. Revisa el correo más reciente o pide otro.',
    credenciais: 'Correo o contraseña incorrectos.',
    bloqueado: 'Demasiados intentos. Espera unos minutos e inténtalo de nuevo.',
    linkTitulo: 'Entrar con el enlace del correo',
    linkTexto: 'Toca el botón para entrar. El enlace vale una sola vez, en este dispositivo.',
    linkEntrar: 'Entrar',
    linkOutroAparelho: 'Este enlace solo vale en el dispositivo en que lo pediste. Escribe el código de 6 dígitos del mismo correo.',
    linkInvalido: 'Enlace inválido, usado o vencido. Pide un código nuevo.',
    golpe: 'Malgo nunca pide contraseña ni código por mensaje o teléfono.',
  },
  convite: {
    titulo: 'Invitación al portal',
    texto: '{{escritorio}} te invitó al portal de la empresa {{empresa}}.',
    termo: 'Términos de uso',
    aceito: 'Leí y acepto los términos de uso',
    entrar: 'Aceptar y entrar',
    invalido: 'Invitación inválida, usada o vencida. Pide una nueva a Malgo.',
    termoObrigatorio: 'Para entrar, acepta los términos de uso.',
  },
  verComo: { titulo: 'Abriendo la vista del equipo', invalido: 'Enlace de vista inválido o vencido. Genera otro en la ficha del cliente.' },
  termo: { titulo: 'Términos de uso actualizados', texto: 'Los términos de uso del portal cambiaron. Léelos y acéptalos para continuar.', aceitar: 'Leí y acepto', versao: 'Versión {{versao}}' },
  saida: {
    titulo: 'Acceso de salida',
    texto: 'El último contrato con el despacho terminó. Hasta el {{data}} todavía puedes consultar los documentos y el historial financiero y descargar tus datos para llevarlos a otro despacho.',
    depois: 'Después de esa fecha, el acceso al portal termina.',
    baixar: 'Descargar mis datos',
    baixarTexto: 'Un archivo con las facturas, las suscripciones y la lista de documentos. Los archivos de cada documento se descargan en Documentos.',
    documentos: 'Ver documentos',
    financeiro: 'Ver historial financiero',
    baixado: 'Datos descargados',
  },
  hoje: {
    titulo: 'Hoy',
    saudacao: 'Hola, {{nome}}',
    tudoEmDia: 'Todo al día.',
    tudoEmDiaTexto: 'Nada depende de ti ahora. Te avisamos cuando llegue algo nuevo.',
    fatura: 'Factura {{numero}}',
    vencida: 'Vencida el {{data}}',
    vence: 'Vence el {{data}}',
    pagar: 'Pagar',
    ver: 'Ver',
    entrega: 'Documento nuevo',
    assinatura: 'Para firmar',
    abrir: 'Abrir',
    mensagem_one: 'Nueva respuesta del equipo',
    mensagem_other: '{{count}} nuevas respuestas del equipo',
    responder: 'Responder',
    lista: 'Lo que depende de ti',
  },
  financeiro: {
    titulo: 'Finanzas',
    abertas: 'Pendientes',
    pagas: 'Pagadas en los últimos 12 meses',
    semAbertas: 'Ninguna factura pendiente.',
    semPagas: 'Ninguna factura pagada en los últimos 12 meses.',
    resumo: 'Resumen de {{ano}}',
    faturado: 'Facturado en el año',
    pago: 'Pagado en el año',
    aberto: 'Pendiente',
    vencido: 'Vencido',
    estado: { em_aberto: 'Pendiente', parcial: 'Pagada en parte', pago: 'Pagada', vencida: 'Vencida' },
    vencimento: 'Vencimiento',
    emissao: 'Emisión',
    competencia: 'Período',
    valor: 'Valor',
    saldo: 'Saldo a pagar',
    pagoEm: 'Pagada el {{data}}',
    parcela: 'Cuota {{parcela}} de {{parcelas}}',
    pix: 'Pix copia y pega',
    qr: 'Código QR del Pix',
    copiar: 'Copiar código',
    copiado: 'Código copiado',
    boleto: 'Línea digitable del boleto',
    copiarLinha: 'Copiar línea digitable',
    abrirBoleto: 'Abrir boleto',
    abrirFatura: 'Abrir la factura en Asaas',
    semCobranca: 'La forma de pago de esta factura todavía se está preparando. Habla con el equipo si necesitas pagar ahora.',
    outraEmpresaTitulo: 'Factura de otra empresa',
    outraEmpresa: 'Esta factura es de una empresa a la que tu cuenta no tiene acceso en este portal. Entra con el correo que recibió el cobro, o habla con el equipo.',
    pagoAgora: 'Pago confirmado. ¡Gracias!',
    voltar: 'Volver a finanzas',
    ateAgora: 'Se actualiza solo cuando llega el pago.',
    assinaturas: {
      titulo: 'Suscripciones',
      vazio: 'Ninguna suscripción activa.',
      pausada: 'Pausada',
      ativa: 'Activa',
      desde: 'Desde {{data}}',
      ate: 'Hasta {{data}}',
      proximas: 'Próximos cobros',
      semProximas: 'Ningún cobro programado.',
      avulso: 'Cobro único',
      recorrencia: { mes_one: 'Cada mes', mes_other: 'Cada {{count}} meses', semana_one: 'Cada semana', semana_other: 'Cada {{count}} semanas', dia_one: 'Cada día', dia_other: 'Cada {{count}} días' },
      ajuda: 'Para cambiar o cancelar una suscripción, habla con el equipo en Mensajes.',
    },
  },
  relatorios: {
    titulo: 'Informes',
    texto: 'Informes que Malgo preparó para su empresa. Cada uno se abre siempre con las cifras del momento.',
    vazio: 'Malgo aún no publicó informes para usted.',
    tipo: { posicao: 'Posición financiera', extrato: 'Extracto del período' },
    publicado: 'Publicado el {{data}}',
    voltar: 'Volver a los informes',
    posicaoEm: 'Facturas abiertas el {{data}}',
    emitidasEntre: 'Facturas emitidas del {{de}} al {{ate}}',
    pagasEntre: 'Facturas pagadas del {{de}} al {{ate}}',
    totais: 'Totales del informe',
    documentos: 'Facturas',
    pago: 'Pagado',
    pagoEm: 'Pago',
    numero: 'Factura',
    atraso: 'Atraso',
    dias_one: '{{count}} día',
    dias_other: '{{count}} días',
    aVencer: 'Por vencer',
    situacao: 'Estado',
    tabela: 'Facturas del informe',
    semFaturas: 'Ninguna factura en el período.',
    truncado: 'Mostrando las primeras {{n}} facturas; los totales suman todas.',
    atualizado: 'Actualizado: las cifras son del momento en que lo abrió.',
  },
  assinar: {
    aba: 'Para firmar',
    vazio: 'Ningún documento para que firmes.',
    situacao: { pendente: 'Esperando tu firma', assinado: 'Firmado', recusado: 'Rechazado', encerrado: 'Cerrado' },
    versao: 'Versión {{versao}}',
    enviado: 'enviado el {{data}}',
    ate: 'firma hasta el {{data}}',
    ler: 'Leer',
    assinar: 'Firmar',
    recusar: 'Rechazar',
    cancelar: 'Cancelar',
    titulo: 'Firmar el documento',
    explicacao: 'Para firmar, confirma con el código que enviamos a tu correo. Quedan registrados la fecha y la hora, tu IP, el navegador y el código del archivo (hash) de esta versión.',
    hash: 'Código del archivo (SHA-256)',
    codigo: 'Código del correo',
    codigoAjuda: 'Seis números. Pide un código nuevo si no llegó.',
    assinado: 'Documento firmado',
    recusarTitulo: 'Rechazar la firma',
    motivo: 'Motivo',
    motivoAjuda: 'El equipo de Malgo recibe el motivo.',
    recusado: 'Firma rechazada',
  },
  documentos: {
    titulo: 'Documentos',
    daMalgo: 'De Malgo',
    enviar: 'Enviar',
    semEntregas: 'Malgo todavía no publicó documentos para ti. Cuando publique, aparecen aquí. Si necesitas mandar un documento, envíalo desde aquí.',
    enviarAgora: 'Enviar un documento',
    novo: 'Nuevo',
    baixar: 'Descargar',
    visto: 'Visto el {{data}}',
    publicado: 'Publicado el {{data}}',
    area: { financeiro: 'Finanzas', dp: 'Personal y nómina', fiscal: 'Fiscal', contabil: 'Contable', societario: 'Societario', geral: 'General' },
    tipo: { extrato: 'Extracto bancario', nota_fiscal: 'Factura fiscal', folha_ponto: 'Registro de horas', admissao: 'Contratación', comprovante: 'Comprobante', contrato: 'Contrato', outro: 'Otro' },
    enviarTitulo: 'Enviar documento a Malgo',
    enviarTexto: 'Toma una foto o elige el archivo: PDF, imagen, hoja de cálculo, documento o XML de factura, hasta 25 MB.',
    arquivo: 'Archivo',
    camera: 'Usar la cámara',
    escolher: 'Elegir archivo',
    tipoCampo: 'Tipo',
    areaCampo: 'Área',
    competenciaCampo: 'Período (opcional)',
    descricaoCampo: 'Observación (opcional)',
    mandar: 'Enviar',
    enviado: 'Documento enviado. Se avisó al equipo.',
    enviados: 'Enviados por tu empresa',
    semEnviados: 'Nada enviado todavía.',
    recebido: 'Recibido por Malgo',
    aguardando: 'Esperando a Malgo',
    meu: 'Enviado por ti',
  },
  mensagens: {
    titulo: 'Mensajes',
    texto: 'Habla con el equipo de Malgo. La respuesta llega aquí y a tu celular.',
    vazia: 'Ningún mensaje todavía. Escribe el primero.',
    escrever: 'Escribe tu mensaje',
    enviar: 'Enviar',
    equipe: 'Equipo Malgo',
    voce: 'Tú',
    estado: { pendente: 'Enviando', entregue: 'Entregado', lida: 'Leído', falhou: 'No enviado' },
    anexar: 'Adjuntar archivo',
    anexarAjuda: 'PDF, imagen, hoja de cálculo, documento o XML de factura, hasta 25 MB',
    removerAnexo: 'Quitar el archivo {{nome}}',
    baixarAnexo: 'Descargar {{nome}}',
    indisponivel: 'Los mensajes por el portal todavía no están activos en tu estudio.',
  },
  perfil: {
    passkeys: 'Passkey',
    passkeysTexto: 'Entra con Face ID, la huella o Windows Hello de este dispositivo, sin código. El código del correo sigue valiendo.',
    cadastrarPasskey: 'Entrar sin contraseña en este dispositivo (passkey)',
    removerPasskey: 'Quitar',
    removerPasskeyTexto: 'Para quitar la passkey "{{nome}}", confirma que eres tú.',
    passkeyRemovida: 'Passkey quitada.',
    passkeyCadastrada: 'Passkey registrada.',
    semPasskey: 'Ninguna passkey registrada.',
    passkeyUsada: 'Último uso: {{data}}',
    titulo: 'Perfil',
    nome: 'Nombre',
    salvarNome: 'Guardar',
    idioma: 'Idioma',
    tema: 'Tema',
    temaSistema: 'Del dispositivo',
    temaClaro: 'Claro',
    temaEscuro: 'Oscuro',
    fonte: 'Tamaño del texto',
    fonteNormal: 'Normal',
    fonteMaior: 'Más grande',
    fonteGrande: 'Grande',
    fonteMuitoGrande: 'Muy grande',
    simples: 'Modo simple',
    simplesAjuda: 'Oculta Informes y el cambio de empresa del menú. Todo se sigue abriendo por enlace.',
    simplesDesligado: 'Desactivado',
    simplesLigado: 'Activado',
    avisos: 'Avisos en el dispositivo',
    avisosTexto: 'Recibe un aviso en el celular cuando haya una factura nueva, un documento o una respuesta del equipo. El aviso no muestra valores ni nombres.',
    ativarAvisos: 'Activar avisos',
    avisosAtivos: 'Avisos activos en este dispositivo',
    desativarAvisos: 'Desactivar en este dispositivo',
    avisosNegados: 'Los avisos están bloqueados en el navegador. Permítelos en la configuración del dispositivo.',
    avisosIos: 'En iPhone y iPad, instala la app: toca Compartir y luego "Agregar a pantalla de inicio".',
    avisosSemSuporte: 'Este navegador no recibe avisos.',
    seguranca: 'Seguridad',
    senha: 'Contraseña (opcional)',
    senhaTexto: 'Entras con el código del correo. Si prefieres, define una contraseña.',
    senhaAtual: 'Contraseña actual',
    confirmacaoTexto: 'Para cambiar la contraseña, registrar o quitar una passkey o anonimizar la cuenta, confirma que eres tú: escribe la contraseña actual o el código que enviamos a tu correo.',
    codigoEmail: 'Código del correo',
    enviarCodigo: 'Enviar código a mi correo',
    codigoEnviado: 'Enviamos un código a tu correo. Vale por 10 minutos.',
    confirmarPasskey: 'Confirma que eres tú',
    senhaNova: 'Nueva contraseña (mínimo 10 caracteres)',
    salvarSenha: 'Guardar contraseña',
    removerSenha: 'Quitar contraseña',
    senhaSalva: 'Contraseña guardada. Se cerraron tus otras sesiones.',
    sairTodos: 'Salir de todos los otros dispositivos',
    sairTodosFeito_one: '{{count}} sesión cerrada',
    sairTodosFeito_other: '{{count}} sesiones cerradas',
    dados: 'Tus datos',
    dadosTexto: 'Descarga todo lo que el portal guarda sobre tu cuenta, o anonimiza la cuenta (sales de todas las empresas).',
    exportar: 'Descargar mis datos',
    anonimizar: 'Borrar mis datos personales (anonimizar)',
    anonimizarTitulo: 'Borrar mis datos personales (anonimizar)',
    anonimizarTexto: 'Tu nombre y correo salen del portal y pierdes el acceso a todas las empresas. Los documentos que la empresa envió siguen con ella. Para confirmar, escribe tu correo y confirma que eres tú con la contraseña actual o el código del correo.',
    confirmacao: 'Tu correo',
    termo: 'Términos de uso aceptados: versión {{versao}} el {{data}}',
    empresa: 'Empresa',
    papel: 'Tu rol',
  },
  // U15 F1: la ayuda de cada pantalla. Los nombres de botones y pestañas salen de las claves de la propia pantalla ($t).
  ajuda: {
    botao: 'Ayuda',
    titulo: 'Ayuda: {{tela}}',
    paraQue: 'Para qué sirve',
    como: 'Cómo hacerlo',
    erro: 'Si algo sale mal',
    deNovo: 'Mostrar de nuevo en la próxima visita',
    deNovoFeito: 'Listo. La ayuda se abre de nuevo la próxima vez que entres en esta pantalla.',
    lerEmVoz: 'Leer en voz alta',
    pararLeitura: 'Detener',
    entendi: 'Entendido',
    hoje: {
      para: 'Aquí está lo que te espera. Si no hay nada, aparece Todo al día.',
      passos: [
        'Mira la lista $t(hoje.lista).',
        'En una factura, toca $t(hoje.pagar).',
        'En un documento nuevo o para firmar, toca $t(hoje.abrir).',
        'En una respuesta del equipo, toca $t(hoje.responder).',
      ],
      erro: 'Si la lista no aparece o algo no abre, avisa al equipo que te atiende.',
    },
    financeiro: {
      para: 'Aquí ves las facturas de tu empresa y cuánto falta pagar.',
      passos: [
        'Mira las facturas en la lista $t(financeiro.abertas).',
        'Toca la factura que quieres pagar.',
        'Toca $t(financeiro.copiar) y paga con Pix en la app de tu banco.',
        'Si prefieres boleto, toca $t(financeiro.copiarLinha) o $t(financeiro.abrirBoleto).',
        'Cuando llegue el pago, la factura sale de $t(financeiro.abertas) sola.',
      ],
      erro: 'Si el pago no aparece o no hay Pix, avisa al equipo que te atiende.',
    },
    mensagens: {
      para: 'Aquí hablas con el equipo de Malgo. La respuesta llega aquí y a tu celular.',
      passos: [
        'Escribe en el campo $t(mensagens.escrever).',
        'Para mandar un archivo, toca el clip ($t(mensagens.anexar)).',
        'Toca $t(mensagens.enviar).',
        'Debajo del mensaje, mira si fue entregado o leído.',
      ],
      erro: 'Si el mensaje queda como No enviado, avisa al equipo que te atiende.',
    },
    documentos: {
      para: 'Aquí están los documentos que Malgo publicó para ti y los que tú envías.',
      passos: [
        'En la pestaña $t(documentos.daMalgo), toca $t(documentos.baixar) para guardar un documento.',
        'Si existe la pestaña $t(assinar.aba), toca $t(assinar.ler) y luego $t(assinar.assinar).',
        'Confirma la firma con el código que llegó a tu correo.',
        'Para mandar, abre la pestaña $t(documentos.enviar) y toca $t(documentos.camera) o $t(documentos.escolher).',
        'Elige el tipo y el área, y toca $t(documentos.mandar).',
      ],
      erro: 'Si el archivo falla o el código no llega, avisa al equipo que te atiende.',
    },
    perfil: {
      para: 'Aquí cuidas tu cuenta, los avisos y la seguridad de tu acceso.',
      passos: [
        'Cambia tu $t(perfil.nome), el $t(perfil.idioma), el $t(perfil.tema) y el $t(perfil.fonte).',
        'En $t(perfil.avisos), toca $t(perfil.ativarAvisos) para recibir alertas en el celular.',
        'Toca $t(perfil.cadastrarPasskey) y confirma que eres tú.',
        'En $t(perfil.dados), toca $t(perfil.exportar) para recibir una copia.',
        'Para quitar tu nombre y correo del portal, toca $t(perfil.anonimizar).',
      ],
      erro: 'Si la confirmación falla, pide otro código o avisa al equipo que te atiende.',
    },
  },
  papel: { dono: 'Dueño', financeiro: 'Finanzas', dp: 'Personal y nómina', fiscal: 'Fiscal', societario: 'Societario', colaborador: 'Colaborador' },
  empresas: { titulo: 'Tus empresas', texto: 'Elige la empresa que quieres ver ahora.', atual: 'Actual', escolher: 'Ver esta' },
  instalar: { titulo: 'Instala la app Malgo', texto: 'Ten el portal en la pantalla de inicio y recibe los avisos.', botao: 'Instalar', depois: 'Ahora no' },
  erros: {
    codigos: {
      'portal.passkey_invalida': 'Passkey no reconocida. Entra con el código del correo.',
      'portal.nao_autenticado': 'Tu sesión terminó. Entra de nuevo.',
      'portal.codigo_invalido': 'Código incorrecto o vencido.',
      'portal.credenciais_invalidas': 'Correo o contraseña incorrectos.',
      'portal.bloqueado': 'Demasiados intentos. Espera unos minutos.',
      'portal.link_outro_aparelho': 'Este enlace solo vale en el dispositivo en que lo pediste. Escribe el código del correo.',
      'portal.link_invalido': 'Enlace inválido, usado o vencido. Pide uno nuevo.',
      'portal.convite_invalido': 'Invitación inválida o vencida.',
      'portal.termo_obrigatorio': 'Acepta los términos de uso para entrar.',
      'portal.termo_pendente': 'Acepta los términos de uso para continuar.',
      'portal.termo_mudou': 'Los términos cambiaron. Lee la nueva versión.',
      'portal.somente_leitura': 'Vista del equipo: solo lectura.',
      'portal.nao_encontrado': 'No encontrado.',
      'portal.area_invalida': 'Área fuera de tu acceso.',
      'portal.senha_atual_incorreta': 'Contraseña actual incorrecta.',
      'portal.confirmacao_incorreta': 'Escribe tu correo para confirmar.',
      'portal.empresa_nao_encontrada': 'Empresa no encontrada.',
      'arquivo.tipo_nao_permitido': 'Tipo de archivo no permitido. Envía PDF, imagen, hoja de cálculo, documento o XML de factura.',
      'arquivo.muito_grande': 'Archivo de más de 25 MB.',
      'portal.envio_limite': 'Llegaste al límite de envíos por ahora (30 por hora y 300 MB por día). Inténtalo más tarde o habla con el equipo.',
      'portal.confirmacao_obrigatoria': 'Confirma con tu contraseña actual o con el código que enviamos a tu correo.',
      'portal.mensagem_limite': 'Llegaste al límite de mensajes por ahora (60 por hora). Inténtalo más tarde.',
      'arquivo.vazio': 'Archivo vacío.',
      'dispositivo.invalido': 'No se pudieron activar los avisos en este dispositivo.',
    },
  },
};
